export * from "./school-day";
export * from "./start-templates";
export * from "./attendance";
export * from "./after-school";
export * from "./follow-up";
export * from "./kartlaggning";

import { schoolDayConversation } from "./school-day";
import { startTemplates } from "./start-templates";
import { schoolAttendanceConversation } from "./attendance";
import { afterSchoolConversation } from "./after-school";
import { followUpConversation } from "./follow-up";
import { kartlaggningTrivselConversation } from "./kartlaggning";
import { ConversationTemplateSchema, type ConversationTemplate } from "@samklang/schemas";

const bundledConversationTemplates: readonly ConversationTemplate[] = [schoolDayConversation, schoolAttendanceConversation, afterSchoolConversation, followUpConversation, kartlaggningTrivselConversation, ...startTemplates];
export const conversationTemplates: ConversationTemplate[] = [...bundledConversationTemplates];

export function usePublishedConversationTemplates(candidates: readonly unknown[]): void {
  const parsed = candidates.map((candidate) => ConversationTemplateSchema.safeParse(candidate)).filter((result) => result.success).map((result) => result.data);
  if (parsed.length === 0) return;
  const remote = new Map(parsed.map((template) => [template.id, template]));
  conversationTemplates.splice(0, conversationTemplates.length, ...bundledConversationTemplates.map((template) => remote.get(template.id) ?? template));
}

export function resetConversationTemplates(): void {
  conversationTemplates.splice(0, conversationTemplates.length, ...bundledConversationTemplates);
}

export function getConversationTemplate(templateId: string) {
  return conversationTemplates.find((template) => template.id === templateId);
}
